import React, { useState } from "react";
import ragalist from "./ragalist";
import { useMediaQuery } from "react-responsive";
// import Audio
let testdata;
function PregnancyRaga({ setExpand, setSelected }) {
  const [testinfo, settestinfo] = useState(false);
  const handletestinfo = (r) => {
    settestinfo(true);
    testdata = r;
  };
  function backtotestlist() {
    settestinfo(false);
  }
  const isTabScreen = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1023px)",
  });
  const isMobile = useMediaQuery({
    query: "(max-width: 767px)",
  });
  const back = {
    fontWeight: "600",
    fontSize: "12px",
    color: "#004AAD",
    cursor: "pointer",
    letterSpacing: "0.3px",
  };
  const heading = {
    color: "#F0588B",
    fontWeight: "600",
    fontSize: isMobile ? "20px" : isTabScreen ? "22px" : "24px",
    paddingTop: "10px",
    paddingBottom: "6px",
  };
  const innercol = {
    marginTop: isMobile ? "16px" : "24px",
    cursor: "pointer",
  };
  const innerrow = {
    paddingRight: 0,
  };
  const testnm = {
    fontSize: isMobile ? "13px" : "14px",
    fontWeight: "500",
    color: "#004AAD",
    minHeight: isMobile ? "44px" : isTabScreen ? "52px" : "58px",
    width: isMobile ? "130px" : "150px",
    padding: "8px 10px",
    backgroundColor: "rgba(251, 251, 251, 0.92)",
    borderRadius: "10px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };

  const para = {
    paddingBottom: "24px",
    fontFamily: "poppins",
    fontSize: isMobile ? "13px" : "14px",
    fontWeight: "400",
    lineHeight: "1.6",
    color: "#333333",
  };
  const parahead = {
    paddingBottom: "10px",
    marginTop: "30px",
    fontFamily: "poppins",
    fontSize: isMobile ? "15px" : "16px",
    fontWeight: "600",
    color: "#333333",
  };
  const wrapper = {
    marginLeft: isMobile ? "12px" : isTabScreen ? "20px" : "50px",
    marginRight: isMobile ? "12px" : isTabScreen ? "20px" : "50px",
    paddingLeft: isMobile ? "12px" : isTabScreen ? "20px" : "28px",
    paddingRight: isMobile ? "12px" : isTabScreen ? "20px" : "28px",
    paddingBottom: "28px",
    background: "#FBFBFB",
    borderRadius: "12px",
    paddingTop: isMobile ? "18px" : "24px",
    marginBottom: "50px",
    minHeight: isMobile ? "auto" : "72vh",
    overflowY: "auto",
  };
  const cardStyle = {
    border: "none",
    borderRadius: "12px",
    overflow: "hidden",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
  };
  const audioStyle = {
    width: "100%",
    maxWidth: "500px",
  };

  return (
    <div style={wrapper}>
      <div>
        {testinfo === true ? (
          <>
            <div style={back} onClick={() => backtotestlist()}>
              BACK
            </div>
            <div style={heading}>{testdata.testname}</div>
            <div style={parahead}>{testdata.infohead}</div>
            <div style={para}>{testdata.info}</div>
            <audio controls style={audioStyle}>
              <source src={testdata.img2} type="audio/mpeg" />
              Your browser does not support the audio element.
            </audio>
          </>
        ) : (
          <>
            <div
              style={back}
              onClick={() => {
                setSelected(false);
                setExpand(true);
              }}
            >
              BACK
            </div>
            <div style={heading}>Pregnancy Raga </div>
            <div className="container">
              <div className="row" style={innerrow}>
                {ragalist.map((r) => (
                  <div
                    className="col-md-4 col-lg-3"
                    style={innercol}
                    onClick={() => handletestinfo(r)}
                    key={r.testname}
                  >
                    <div className="card text-white" style={cardStyle}>
                      <img src={r.img} className="card-img" alt="..."></img>
                      <div className="card-img-overlay d-flex justify-content-center align-items-center">
                        <div style={testnm}>
                          <div className="card-title text-center">
                            {r?.testname}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
export default PregnancyRaga;
